const misc = {
    roundedBorders: '0.25rem',
    shadow: `0 10px 15px -3px rgb(0 0 0 / 0.1),0 4px 6px -4px rgb(0 0 0 / 0.1)`,
};

export default misc;
